import API from "../constants/api.constant";
import { responseErrorHandling } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

export type TaskCategory = "Lead" | "Deal" | "Other";
export type TaskStatus = "To Do" | "In Progress" | "Completed";
export type TaskAssigneeType = "Unassigned" | "Employee" | "Co-owner";

export interface TaskPayload {
  title: string;
  description?: string;
  category: TaskCategory;
  status: TaskStatus;
  followUpDate?: string | null;
  assigneeType: TaskAssigneeType;
  assigneeId?: string | null;
  leadId?: string | null;
  dealId?: string | null;
}

export interface Task extends TaskPayload {
  id: string;
  createdAt: string;
  updatedAt: string;
  canDelete?: boolean;
  createdById?: string | null;
  createdByBusinessId?: string | null;
  lead?: {
    id: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    businessName?: string;
    email?: string | null;
    phone?: string | null;
  } | null;
  deal?: {
    id: string;
    loanName?: string;
    dealType?: string;
    loanSize?: number;
    status?: string;
  } | null;
  assignee?: {
    id: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
  } | null;
}

export const getTasks = async (): Promise<Task[] | undefined> => {
  try {
    const response = await axiosInstance.get(API.TASKS);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const createTask = async (payload: TaskPayload): Promise<Task | undefined> => {
  try {
    const response = await axiosInstance.post(API.TASKS, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const updateTask = async (
  id: string,
  payload: TaskPayload
): Promise<Task | undefined> => {
  try {
    const response = await axiosInstance.patch(`${API.TASKS}/${id}`, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const deleteTask = async (id: string) => {
  try {
    const response = await axiosInstance.delete(`${API.TASKS}/${id}`);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};
